// src/store/useDetalleStore.ts
import { create } from "zustand";
import { IDataCuadre, ISerieCuadre } from "./useCuadreInventario";
import { arrayToRecordBy, EstadoGestionInventarioENUM } from "@/shared";
import { IDataProducto } from "@/shared/interfaces";

type State = {
  interactions: Record<string, IDataCuadre>;
  setInteractions: (interactions: Record<string, IDataCuadre>) => void
  upsertInteraction: (rowId: string, patch: Partial<IDataCuadre>) => void;

  // Modal state
  seriesModalOpen: boolean;
  activeParentRowId: string | null;
  ubicacion: string | null;
  producto: string | null;

  // Aux informacion de producto
  dataProducto: IDataProducto | null
  setDataProducto: (dataProducto: IDataProducto | null) => void

  // Data del modal (viene de API)
  seriesRows: ISerieCuadre[];
  seriesLoading: boolean;

  // Hashmap del modal: seriesId -> cambios del usuario
  seriesInteractions: Record<string, ISerieCuadre>;
  upsertSeriesInteraction: (seriesId: string, patch: Partial<ISerieCuadre>) => void;

  // Open/close modal
  openSeriesModal: (parentRowId: string, ubicacion: string, producto: string) => Promise<void>;
  closeSeriesModal: () => void;

  // Guardar modal -> se persiste en el padre (interactions[parentRowId].series)
  saveSeriesToParent: () => void;

  // Limpiar store
  cleanCuadre: () => void
};


export const useDetalleStore = create<State>((set, get) => ({
  setInteractions(interactions) {
    set({
      interactions
    })
  },
  cleanCuadre() {
    set({
      seriesModalOpen: false,
      activeParentRowId: null,
      seriesRows: [],
      seriesInteractions: {},
      seriesLoading: false,
      dataProducto: null,
      interactions: {},
      ubicacion: null,
      producto: null,
    })
  },
  dataProducto: null,
  setDataProducto(dataProducto) {
    set({
      dataProducto
    })
  },
  producto: null,
  ubicacion: null,
  interactions: {},
  upsertInteraction: (rowId, patch) =>
    set((state) => ({
      interactions: {
        ...state.interactions,
        [rowId]: { ...(state.interactions[rowId] ?? {}), ...patch },
      },
    })),

  seriesModalOpen: false,
  activeParentRowId: null,

  seriesRows: [],
  seriesLoading: false,

  seriesInteractions: {},
  upsertSeriesInteraction: (seriesId, patch) =>
    set((state) => ({
      seriesInteractions: {
        ...state.seriesInteractions,
        [seriesId]: { ...(state.seriesInteractions[seriesId] ?? {}), ...patch },
      },
    })),

  openSeriesModal: async (parentRowId, ubicacion, producto) => {

    const {
      interactions
    } = get();

    let map = {}
    const find = interactions[parentRowId]?.series
    if (find) {
      map = arrayToRecordBy(find, (x) => x.serie);
    }

    set({
      ubicacion,
      producto,
      seriesInteractions: map,
      seriesModalOpen: true,
      activeParentRowId: parentRowId ?? {},
      //seriesInteractions: {}, // no precargar, no guardar nada local
    })
  },

  closeSeriesModal: () =>
    set({
      seriesModalOpen: false,
      activeParentRowId: null,
      seriesRows: [],
      seriesInteractions: {},
      seriesLoading: false,
    }),

  saveSeriesToParent: () => {
    const parentRowId = get().activeParentRowId;

    if (!parentRowId) return;

    const {
      seriesInteractions,
      upsertInteraction,
      closeSeriesModal,
    } = get();

    const arrWithKey: ISerieCuadre[] = Object.entries(seriesInteractions).map(([key, value]) => ({
      key,
      check: value.check,
      observacion: value.observacion,
      serie: value.serie,
      cantidad_gestion: value.cantidad_gestion ?? 0,
      tipo_gestion: value.tipo_gestion ?? EstadoGestionInventarioENUM.NO_REQUIERE,
      id_serie: value.id_serie
    }));

    upsertInteraction(parentRowId, {
      series: arrWithKey
    });

    // Cerrar modal
    closeSeriesModal();
  },
}));
